import { get, postWithHeaders } from "../../../../server/actions";
import moment from 'moment';

export const getTeachers=({schoolId,schoolYear})=>{
    let url=`/cep/${schoolId}/teachersByGrade/${schoolYear}?access_token=`;
    return get(url);
}
export const getTransactions=({schoolId,mealType,selectedDate})=>{
    const url=`/cep/${schoolId}/menuWithorders/${mealType}/${selectedDate.format('YYYY-MM-DD')}?access_token=`;
    return get(url);
}
export const saveItemTransaction=({
    schoolId, mealType, userId,reqBody
})=>{
    let headers = {
        'Content-Type': 'application/json'
    };
    const url=`/cep/${schoolId}/transactions/${mealType}?deviceId=${userId}&access_token=`;
    return postWithHeaders(url, JSON.stringify(reqBody), headers);
}


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/bulkTransactions/bulkTransactionService.js